import { useAuth } from '../context/AuthContext';

/**
 * Whether the current user may raise a helpdesk ticket.
 *
 * Tickets are scoped to a UDA (hlpd_tckt_dtl_t.uda_id). That used to be taken from the
 * JWT's udaId alone, so State / DTCP users (udaId null, or 0 for "All UDAs") were
 * hidden from every Create Ticket entry point. The New Ticket form now asks which UDA
 * the ticket belongs to and sends it as `uda_id`, which resolveHelpdeskUdaId honours for
 * a state user (a UDA user stays pinned to their own). So any signed-in user may raise
 * one; the save still refuses a ticket with no UDA server-side.
 */
export const useCanCreateTicket = (): boolean => {
  const { user } = useAuth();
  return !!user;
};

export default useCanCreateTicket;
